module.exports = __webpack_public_path__ + "img/Graph.e7da2e12.svg";